import { SelectItem } from 'primeng/api';
import { UserService } from 'src/app/users/shared/user.service';
import { Component, OnInit, Input, ViewEncapsulation, OnChanges, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { RevenueItemService } from 'src/app/revenue/shared/revenue-items/revenue-item.service';
import { ContactSearchDto, initializeContactSearchDto } from '../../shared/contact-search.dto';
import { ContactService } from '../../shared/contact.service';
import { ContactTypeService } from '../../contact-type/shared/contact-type.service';
import { ContactType } from '../../contact-type/shared/contact-type.model';
import { ContactTypeSearchParams } from '../../contact-type/search/contact-type-search-params.model';

@Component({
  selector: 'wl-contact-record-search-params',
  templateUrl: './contact-record-search-params.component.html',
  styleUrls: ['./contact-record-search-params.component.less'],
  encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ContactRecordSearchParamsComponent implements OnInit {
  @Input()
  get searchParams() {
    return this._searchParams;
  }
  set searchParams(value: ContactSearchDto) {
    this._searchParams = value;
    this.searchParamsChange.emit(this._searchParams);
  }
  @Output() searchParamsChange = new EventEmitter<ContactSearchDto>();
  allContactTypes: ContactType[];
  selectedContactTypes: ContactType[];
  contactTypesSearchResults: ContactType[];

  private _searchParams: ContactSearchDto;

  constructor(private _contactTypeService: ContactTypeService) {
    this.searchParams = initializeContactSearchDto();
  }

  ngOnInit(): void {
    this._contactTypeService.getContactTypes({ PageSize: 999 }).then((items) => {
      this.allContactTypes = items.Result;
    });
  }

  searchContactTypes(event: any) {
    this.contactTypesSearchResults = this.allContactTypes
      ?.filter((ct) => ct.ContactType.toLowerCase().includes(event.query?.toLowerCase()))
      .filter((x) => !this.selectedContactTypes?.find((y) => x === y));
  }

  syncItems() {
    this.searchParams.ContactTypes = this.selectedContactTypes.map((x) => x.ContactType);
  }

  clearSelectedContactTypes() {
    this.selectedContactTypes = [];
  }
}
